var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-bar-box"},[_c('div',{staticClass:"btn-back",on:{"click":function($event){return _vm.back()}}},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" 返回 ")]),_c('div',{staticClass:"line"}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }